import { useTranslation } from 'react-i18next';
import React from 'react';
import { trDisplay } from '../../i18n';
import { Play, Settings } from 'lucide-react';

/**
 * Overlay shown when no simulation has been run yet.
 * Displays over the placeholder results area to guide the user.
 */
const EmptyStateOverlay = ({ variant = 'lombard', onConfigure }) => {
  useTranslation();
  const colors = variant === 'lombard'
    ? {
        bg: 'from-emerald-500/10 to-teal-500/10',
        border: 'border-emerald-200',
        icon: 'bg-emerald-100 text-emerald-600',
        text: 'text-emerald-800',
        badge: 'bg-emerald-100 text-emerald-700'
      }
    : {
        bg: 'from-blue-500/10 to-indigo-500/10',
        border: 'border-blue-200',
        icon: 'bg-blue-100 text-blue-600',
        text: 'text-blue-800',
        badge: 'bg-blue-100 text-blue-700'
      };

  return (
    <div
      className={`absolute inset-0 z-10 flex items-center justify-center bg-gradient-to-br ${colors.bg} backdrop-blur-[2px] rounded-xl`}
      data-testid="empty-state-overlay"
    >
      <div className={`bg-white/95 ${colors.border} border rounded-2xl p-6 sm:p-8 max-w-md mx-4 shadow-xl text-center`}>
        <div className={`w-16 h-16 ${colors.icon} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
          <Play className="h-8 w-8" />
        </div>
        <h3 className={`text-lg sm:text-xl font-bold ${colors.text} mb-2`}>
          {trDisplay('Nessuna simulazione ancora eseguita')}
        </h3>
        <p className="text-slate-600 text-sm sm:text-base mb-4">
          {trDisplay(variant === 'swr' ? 'Apri «Modifica configurazione», imposta i parametri e premi' : 'Imposta i parametri nella colonna a sinistra e premi')}{' '}
          <strong>“{trDisplay('Esegui simulazione')}”</strong>{' '}{trDisplay('per vedere i risultati.')}
        </p>
        <div>
        {variant === 'swr' && onConfigure ? <button type="button" onClick={onConfigure} className={`inline-flex min-h-11 items-center gap-2 ${colors.badge} px-3 py-1.5 rounded-md text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600`}><Settings className="h-4 w-4" aria-hidden="true" />{trDisplay('Modifica configurazione')}</button> : <div className={`inline-flex items-center gap-2 ${colors.badge} px-3 py-1.5 rounded-full text-sm`}>
          <Settings className="h-4 w-4" />
          <span>{trDisplay('Configura i parametri')}</span>
        </div>}
        </div>
      </div>
    </div>
  );
};

export default EmptyStateOverlay;
